import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { ModalPopUp } from "../ModalPopUp";
import Spinner from "../Spinner";
import "./index.scss";

export const ModalVideo = ({
  modalVideo,
  setModalVideo,
  videoUrl,
  posterUrl,
  title = "Bem Vindo ao IntegraAdmin",
}: {
  modalVideo: boolean;
  setModalVideo: Dispatch<SetStateAction<boolean>>;
  videoUrl: string;
  posterUrl: string;
  title?: string;
}) => {
  const videoPlayer = useRef(null);
  const [needSpinnerVideo, setNeedSpinnerVideo] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      videoPlayer.current.play();
    }, 2500);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setNeedSpinnerVideo(false);
    }, 1000);
  }, []);

  return (
    <ModalPopUp status={modalVideo} onClickCancel={() => setModalVideo((oldValue) => !oldValue)} title={title} className="modal-video">
      <div className="flex justify-center">
        <Spinner status={needSpinnerVideo}>
          <video ref={videoPlayer} controls src={videoUrl} poster={posterUrl} preload="">
            Este vídeo pode não estar disponível
            <a href={videoUrl} target="_blank">
              {" "}
              Baixe aqui
            </a>
            se este for o caso
          </video>
        </Spinner>
      </div>
    </ModalPopUp>
  );
};
